/* eslint-disable react/no-danger */
import {
  Box,
  Card,
  Grid2,
  Show,
  StatusField,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "components";
import { SingleStockItemInterface } from "interfaces/EquityBasket";
import { groupBy } from "lodash";
import { matchDate } from "utils/helpers";

const RationaleTimeline = ({
  rationaleTimeline,
  researchFiles,
}: {
  rationaleTimeline: Pick<
    SingleStockItemInterface,
    "stockUniverseItemHistory"
  >[];
  researchFiles: Pick<SingleStockItemInterface, "researchFiles">[];
}) => {
  const data = Object.entries(
    groupBy(
      [...rationaleTimeline, ...researchFiles]?.map((d: any) => {
        return {
          ...d,
        };
      }),
      "date",
    ),
  ).map(([key, val]) => {
    return {
      key,
      researchFiles: val?.filter((d) => d?.file) || [],
      rationaleTimeline: val?.filter((d) => d?.rationale)[0] || {},
    };
  });

  return (
    <Stepper activeStep={-1} orientation="vertical" sx={{ width: "60%" }}>
      {data?.map((step, index) => (
        <Step key={index} expanded>
          <StepLabel>
            <Box display={"flex"} alignItems={"center"} gap={1}>
              {step?.key && (
                <Typography fontSize={12} fontWeight={600} color="#222">
                  {matchDate(step?.key)}
                </Typography>
              )}
              <Typography>•</Typography>
              {step?.rationaleTimeline?.recommendationType && (
                <StatusField
                  statusString={step?.rationaleTimeline?.recommendationType}
                />
              )}
            </Box>
          </StepLabel>
          <StepContent>
            <Grid2 container spacing={2}>
              <Grid2 size={12}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: step?.rationaleTimeline?.rationale,
                  }}
                />
              </Grid2>
              <Show.When isTrue={step?.researchFiles?.length !== 0}>
                <Grid2 size={12}>
                  <Typography variant="primaryLight">
                    Research Files ({step?.researchFiles?.length})
                  </Typography>
                </Grid2>
                {step?.researchFiles?.map((dataItem: any) => {
                  return (
                    <Grid2 size={6}>
                      <Grid2 container key={index}>
                        <Grid2 size={12}>
                          <Card
                            sx={{
                              borderColor: "var(--neutral-100)",
                              mb: 1,
                              p: 1,
                              borderRadius: 2,
                            }}
                          >
                            <Grid2 container alignItems={"center"}>
                              <Grid2
                                container
                                alignContent={"center"}
                                gap={1}
                                size={11}
                              >
                                <Grid2 display={"flex"} alignItems={"center"}>
                                  <img
                                    src={`/FileIcons/${(dataItem?.name || "")
                                      .split(".")
                                      .pop()}.svg`}
                                    height={30}
                                    width={30}
                                    alt=""
                                    style={{
                                      borderRadius: 4,
                                      border: "1px solid",
                                      borderColor: "var(--neutral-100)",
                                      padding: 4,
                                    }}
                                  />
                                </Grid2>
                                <Grid2>
                                  <Typography fontSize={12} fontWeight={600}>
                                    {dataItem?.name}
                                  </Typography>
                                </Grid2>
                              </Grid2>
                            </Grid2>
                          </Card>
                        </Grid2>
                      </Grid2>
                    </Grid2>
                  );
                })}
              </Show.When>
            </Grid2>
          </StepContent>
        </Step>
      ))}
    </Stepper>
  );
};

export default RationaleTimeline;
